import { lazy, Suspense } from "react";
import { useLazyVisible } from "@/common/hooks/useLazyVisible";

const FooterComponent = lazy(
  () =>
    import(/* webpackChunkName: "footer", webpackPrefetch: true */ "./Footer"),
);

export function Footer() {
  const { ref, isVisible } = useLazyVisible<HTMLDivElement>();

  return (
    <div ref={ref}>
      {isVisible && (
        <Suspense fallback={null}>
          <FooterComponent />
        </Suspense>
      )}
    </div>
  );
}
